export enum ActionTypes {
  // the 'GetPackages' action is for loading state
  GetPackages = 'getPackages',
  GetPackagesRequest = 'getPackages.request',
  GetPackagesSuccess = 'getPackages.success',
  GetPackagesFailure = 'getPackages.failure',
}
